import React from 'react';
import LocaleLinks from '../../locale/LocaleLinks';
import { useTranslation } from 'react-i18next';

import { Message } from '../../../core/components';

// custom error message for the results table
export const ResultsTableEmptyMsg: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Message type='empty' title={t('results_order_emptyListTitle')}>
      <div className='fcolor--text-label font-size-14'>
        <LocaleLinks
          localeKey='results_order_emptyListDescription'
          links={[{ name: 'emptyResults', route: '/uploads' }]}
        />
      </div>
    </Message>
  );
};
